// extracted by mini-css-extract-plugin
module.exports = {"Checkbox__root":"Checkbox_Checkbox__root__ZJR8p","checked":"Checkbox_checked__222F5","disabled":"Checkbox_disabled__39rsN","Label":"Checkbox_Label__yGwL4"};